
import Vue from "vue";
import Component from "vue-class-component";
import toast from "@/functions/toast.function";
import { Action, State } from "vuex-class";
import type { SalesToken } from "@/store/school/types";
import { SalesTokenModuleEnum } from "@/store/school/types";
import { Watch } from "vue-property-decorator";

@Component<TokenValidation>({
  data(vm) {
    return { captchaLoaded: false };
  },
  beforeCreate() {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js`;
    script.onload = () => (this.captchaLoaded = true);
    document.head.appendChild(script);
  },
})
export default class TokenValidation extends Vue {
  @Action("schoolRequestValidateToken", { namespace: "school" })
  schoolRequestValidateToken!: ServiceCall<
    Respon<SalesToken>,
    { sales_token: string }
  >;

  @State("salesToken", { namespace: "school" }) salesToken!: SalesToken;

  tokenCode = "";
  isLoading = false;
  tokenValid = false;
  tokenInvalid = false;
  isVerifying = false;
  captchaReady = false;
  captchaLoaded!: boolean | undefined;
  widgetID!: number;

  @Watch("tokenCode")
  onTokenCodeCChange() {
    if (this.captchaReady) {
      const { reset } = window.grecaptcha;
      reset(this.widgetID);
      this.captchaReady = false;
    }
  }

  setCookie(cname, cvalue) {
    const d = new Date();
    d.setTime(d.getTime() + 2 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  verifyToken() {
    if (this.tokenCode.length !== 6) {
      toast.error("Silakan masukkan 6 karakter kode pendaftaran");
      return;
    }

    const setInitialState = () => {
      this.isLoading = true;
      this.tokenValid = false;
      this.tokenInvalid = false;
    };
    setInitialState();

    const { ready, render } = window.grecaptcha;
    this.captchaReady = true;
    ready(() => {
      const ref = this.$refs["recaptcha"];
      if (Array.isArray(ref) || !ref) {
        return console.error("invalid recaptcha elemennt reference");
      }

      const container = ("$el" in ref ? ref.$el : ref) as HTMLElement;

      this.schoolRequestValidateToken({
        config: {
          hideToaser: true,
        },
        params: { sales_token: this.tokenCode },
        success: ({
          data: {
            data: { module, token },
          },
        }) => {
          this.widgetID = render(container, {
            sitekey: "6LdO-a8UAAAAAI7Ecl4c3B6wXtxnGB1_chhD4dex",
            "error-callback": setInitialState,
            "expired-callback": setInitialState,
            callback: (resonse) => {
              this.setCookie("g-recaptcha-response", resonse);
              switch (module) {
                case SalesTokenModuleEnum.JOBFAIR: {
                  this.$router.push({
                    name: "register-jobfair",
                    query: { token },
                  });
                  break;
                }
                case SalesTokenModuleEnum.SCHOOL: {
                  this.$router.push({
                    name: "register-school",
                    params: { code: token },
                  });
                  break;
                }

                default: {
                  toast.error("Invalid Module!");
                  break;
                }
              }
            },
          });

          this.tokenValid = true;
          this.tokenInvalid = false;
        },
        fail: (e) => {
          this.tokenValid = false;
          this.tokenInvalid = true;
        },
        finally: () => {
          this.isLoading = false;
        },
      });
    });
  }

  async verifyCaptcha() {
    if (this.isVerifying) return;

    if (!window.grecaptcha) {
      toast.error(
        "reCAPTCHA belum dimuat, mohon tunggu sebentar dan coba lagi"
      );

      return;
    }

    try {
      this.isVerifying = true;
      const { execute } = window.grecaptcha;
      const r = execute("6LeUpvYqAAAAAJWBhXBq1kqzIF0BeTxVRv4-7ewh", {
        action: "verify_token",
      });
      if (!r) return new Error("Invalid captcha");

      this.isVerifying = false;
    } catch (error) {
      console.error("reCAPTCHA error:", error);
      toast.error("Gagal memverifikasi keamanan, silakan coba lagi");
    }
  }
}
